module.exports = __webpack_public_path__ + "img/ticket_icon.fddf3b14.svg";